export interface ErrorClassification {
  error_kind: string;
  error_name?: string;
  status_code?: number;
}

function statusFromResponse(error: Record<string, unknown>): number | undefined {
  const response = error.response;
  if (response && typeof response === "object") {
    const status = (response as Record<string, unknown>).status;
    return typeof status === "number" ? status : undefined;
  }
  return;
}

function readNumericStatus(error: unknown): number | undefined {
  if (!error || typeof error !== "object") {
    return;
  }

  const record = error as Record<string, unknown>;
  const directStatus = record.status ?? record.statusCode;
  return typeof directStatus === "number" ? directStatus : statusFromResponse(record);
}

function errorKind(errorName: string, statusCode: number | undefined): string {
  const lowerName = errorName.toLowerCase();
  if (typeof statusCode === "number") {
    return "http_error";
  }
  if (lowerName.includes("network") || lowerName.includes("fetch")) {
    return "network_error";
  }
  if (lowerName.includes("validation") || lowerName.includes("zod")) {
    return "validation_error";
  }
  return "application_error";
}

/** Classifies an unknown error into safe dimensions. */
export function classifyError(error: unknown): ErrorClassification {
  const statusCode = readNumericStatus(error);
  const errorName = error instanceof Error ? error.name : "";
  return {
    error_kind: errorKind(errorName, statusCode),
    ...(errorName ? { error_name: errorName } : {}),
    ...(typeof statusCode === "number" ? { status_code: statusCode } : {}),
  };
}
